module.exports = __webpack_public_path__ + "static/media/PlayDisabled.3e2d1d9b.svg";